import { render, staticRenderFns } from "./copygiftmodify.vue?vue&type=template&id=5c06e784&scoped=true&"
import script from "./copygiftmodify.vue?vue&type=script&lang=js&"
export * from "./copygiftmodify.vue?vue&type=script&lang=js&"
import style0 from "./copygiftmodify.vue?vue&type=style&index=0&id=5c06e784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06e784",
  null
  
)

export default component.exports